module.exports = __webpack_public_path__ + "img/icb-co-elite-e@3x.7545bef1.png";